import React, { useEffect } from 'react';
import {
	BottomNavigation,
	BottomNavigationAction,
	Paper,
	Tooltip,
	Typography,
	AppBar,
	Toolbar,
	IconButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HistoryIcon from '@material-ui/icons/History';
import InfoIcon from '@material-ui/icons/Info';
import ReplayIcon from '@material-ui/icons/Replay';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';
import SearchIcon from '@material-ui/icons/Search';

import PropTypes from 'prop-types';
import { Rnd } from 'react-rnd';
import CloseIcon from '@material-ui/icons/Close';
import BuildIcon from '@material-ui/icons/Build';
import { useActions, useValues } from 'kea';
import { infowindowlogic } from 'src/store/global';

import HistoryPanel from './Tabs/history';
import InfoPanel from './Tabs/Info';
import ReplayPanel from './Tabs/replay';
import ActionPanel from './Tabs/Actions';
import NearbyAssetsPanel from './Tabs/NearbyAssets';
import checkRole from 'src/utils/checkRole';
import profilelogic from 'src/store/profile';
import alertlogic from 'src/store/alert';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<>
					{children}
				</>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};


const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: 0,
		flexGrow: 1,
		minWidth: 200
	},
	limitHeight: {
		// minHeight:35,
	},
	BottomNavigation: {
		marginTop: "16px",
	},
	TabPanel: {

	},
	title: {
		flexGrow: 1,
		display: 'none',
		[theme.breakpoints.up('sm')]: {
			display: 'block',
		},
	},

}));

export default function TrackerInfoWindow() {
	const classes = useStyles();

	const { vehicle } = useValues(infowindowlogic);
	const { set } = useActions(infowindowlogic);
	const { profile } = useValues(profilelogic);

	const { alerts } = useValues(alertlogic);
	const { fetchAll: AlertFetchAll } = useActions(alertlogic);

	const [value, setValue] = React.useState(0);

	useEffect(() => {
		if (checkRole(profile, ['AlertView'], true)) {
			alerts ?? AlertFetchAll();
		}
	}, []); // eslint-disable-line

	let count = 0;

	const handleClose = () => {
		set(null);
	}

	const handle_focus = () => {
		const pos = vehicle.tracker.status[0];
		if (pos) {
			global.gmap.panTo({
				lat: pos.latitude,
				lng: pos.longitude
			})
			global.gmap.setZoom(20);
		}
	}

	if (!vehicle) {
		return null;
	}
	return (
		<Rnd
			default={{
				x: 600,
				y: 500,
				width: 550,
			}}
			enableResizing={false}
			bounds={"#panelHolder"}
			disableDragging={false}
			cancel={
				"#rnd-ignore-drag"
			}
		>
			<Paper className={classes.root} style={{ maxWidth: 550, maxHeight: 500 }}>
				<div style={{
					flexGrow: 1,
				}}>
					<AppBar className="handle cursor" position="static">
						<Toolbar variant="dense">
							<div id={'rnd-ignore-drag'}>
								<Tooltip title='Find on map'>
									<IconButton onClick={handle_focus} aria-label="less" className={classes.margin} >
										<SearchIcon htmlColor='white' />
									</IconButton>
								</Tooltip>
							</div>
							<Typography className={classes.title} variant="h6" noWrap>
								{`${vehicle.type} - ${vehicle.registration_number} - ${vehicle.name}`}
							</Typography>
							<div id={'rnd-ignore-drag'}>
								<Tooltip title='Close'>
									<IconButton onClick={handleClose} aria-label="less" className={classes.margin} >
										<CloseIcon htmlColor='white' />
									</IconButton>
								</Tooltip>
							</div>
						</Toolbar>
					</AppBar>
				</div>

				<div id={'rnd-ignore-drag'} className={classes.root} style={{ cursor: 'default' }}>
					<TabPanel value={value} index={count++} >
						<InfoPanel vehicle={vehicle} />
					</TabPanel>
					<TabPanel value={value} index={count++}>
						<NearbyAssetsPanel vehicle={vehicle} />
					</TabPanel>
					<TabPanel value={value} index={count++}>
						<HistoryPanel vehicle={vehicle} />
					</TabPanel>
					<TabPanel value={value} index={count++}>
						<ReplayPanel vehicle={vehicle} />
					</TabPanel>
					<TabPanel value={value} index={count++}>
						<ActionPanel vehicle={vehicle} />
					</TabPanel>
					<BottomNavigation
						value={value}
						onChange={(event, newValue) => {
							setValue(newValue);
						}}
						showLabels
						className={classes.BottomNavigation}
					>
						<BottomNavigationAction label="Information" icon={<HistoryIcon />} />
						<BottomNavigationAction label="Nearby Assets" icon={<SettingsRemoteIcon />} />
						<BottomNavigationAction label="Movement History" icon={<InfoIcon />} />
						<BottomNavigationAction label="Replay Route" icon={<ReplayIcon />} />
						<BottomNavigationAction label="Actions" icon={<BuildIcon />} />
					</BottomNavigation>
				</div>
			</Paper>
		</Rnd>
	);
}
